import React from 'react';
import Dialog from 'material-ui/Dialog';
import {FlatButton, TextField} from 'material-ui';

const UpdateSpecialityDialog = ({selectedSpeciality, open, specialityTitle, onChange, updateSpeciality, toggleUpdateSpeciality}) => {
  const styles = {
    select: {
      width: '30%'
    },
    timePicker: {
      marginLeft: '50px'
    },
    label: {
      marginTop: '25px',
    },
    labelTime: {
      marginTop: '25px',
      marginLeft: '55px'
    }
  }
  const actions = [
    <FlatButton
      label="Cancel"
      secondary={true}
      onTouchTap={toggleUpdateSpeciality} />,
    <FlatButton
      label="Update"
      primary={true}
      onTouchTap={updateSpeciality.bind(null)} 
      />
  ];

  return (
    <div>
      <Dialog
        title='Update Speciality'
        actions={actions}
        modal={false}
        open={open}
        autoScrollBodyContent={true}
        onRequestClose={toggleUpdateSpeciality.bind(null, false, {})} >
        <div className="row" style={styles.label}>
        <label>Current Speciality Title: {selectedSpeciality && selectedSpeciality.speciality}</label>
        </div>
        <TextField
        name="Speciality Title"
        value={specialityTitle}
        underlineShow={true}
        onChange={onChange.bind(null, "specialityTitle")}
        />
      </Dialog>
    </div>
  )
};

export default UpdateSpecialityDialog;


// WEBPACK FOOTER //
// ./src/screens/update-speciality/index.js